import React, { Component, Fragment } from 'react';
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Redirect } from "react-router";
import { withTranslation } from "react-i18next";
import Header from "./Parts/Header";
import SubHeader from "./Parts/SubHeader";
import SIF from "./Parts/SIF";
import ReactBootstrapSlider from 'react-bootstrap-slider';
import Loading from "./Parts/Loading";
import NumberFormat from 'react-number-format';
import Proposition from "./Parts/Proposition";
import ContractPreview from "./Parts/ContractPreview";
import AppContext from "../../contexts/AppContext";
import NumberLoading from "./Parts/NumberLoading";
import { decodeData } from "../../helpers";

const CancelToken = axios.CancelToken;
let cancelMonthlyPaymentRequests;

class ChooseTerms extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            max_amount_proposition: {
                amount: null,
                monthly_payment: null,
                term: null
            },
            initial_proposition: {
                amount: null,
                monthly_payment: null,
                term: null
            },
            current_proposition: {
                amount: null,
                term: null,
                monthly_payment: null,
            },
            slider_ranges: {
                min_amount: 1,
                max_amount: 150000,
                min_term: 1,
                max_term: 72
            },
            payment_day: 0,
            options: {},
            application: null,
            deal: null,

            is_modal_shown: false,
            is_preview_modal_shown: false,

            redirectToNextStep: false,
            redirectToSpouseStep: false,
            redirect_url: null,

            step_count: 4,
            current_step: 1,

            options_error: false,
            gtmScoringEventSent: false,
            appl_status_code: null,
        };

        this.calculatorRef = React.createRef();

        this.renderTermForm = this.renderTermForm.bind(this);
        this.getOptions = this.getOptions.bind(this);
        this.updateAmountFromSlider = this.updateAmountFromSlider.bind(this);
        this.updateTermFromSlider = this.updateTermFromSlider.bind(this);
        this.getMonthlyPayment = this.getMonthlyPayment.bind(this);
        this.setTermToClosestAvailable = this.setTermToClosestAvailable.bind(this);
        this.setAmountToClosestAvailable = this.setAmountToClosestAvailable.bind(this);
        this.setAmountSliderRange = this.setAmountSliderRange.bind(this);
        this.updateMonthlyPaymentInBottom = this.updateMonthlyPaymentInBottom.bind(this);
        this.choosePaymentDay = this.choosePaymentDay.bind(this);
        this.scrollToCalculator = this.scrollToCalculator.bind(this);
        this.hideSIFModal = this.hideSIFModal.bind(this);
        this.showSif = this.showSif.bind(this);
        this.hidePreviewModal = this.hidePreviewModal.bind(this);
        this.canShowInitialProposition = this.canShowInitialProposition.bind(this);
        this.showPreview = this.showPreview.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.redirectToNextStep === true) {
            gtm.sendEvent('base', {
                orderID: this.props.suggestion.application.id,
                event: 'checkoutoffer',
                products: {
                    amount: this.state.current_proposition.amount,
                    variant: this.state.current_proposition.term,
                },
                actionField: { step: 6, action: 'offerChoice' },
                pageTitle: 'Loan offer chosen 2/4',
                eventId: 1290
            });
            //new version
            gtm.sendEvent('base', {
                event: 'loan_contract_signing.started',
                products: {
                    loan_amount: this.state.current_proposition.amount,
                    loan_period: this.state.current_proposition.term,
                    product_code: this.props.suggestion.application.product_code,
                    application_number: this.props.suggestion.application.id,
                }
            }, 2);

        }
        else if (
            this.props.suggestion.application.id !== undefined
            && this.props.suggestion.application.id !== null
            && !this.state.gtmScoringEventSent
            && (this.state.appl_status_code !== null || this.props.suggestion.application.appl_status_code != undefined)
        ) {
            gtm.sendEvent('base', {
                orderID: this.props.suggestion.application.id,
                event: 'checkscoring',
                products: {
                    max_amount: this.state?.max_amount_proposition?.amount,
                    max_variant: this.state?.max_amount_proposition?.term,
                    product_code: this.props.suggestion.application.product_code || this.props.suggestion.application.appl_product,
                    applStatusCode: this.props.suggestion.application.appl_status_code || this.state.appl_status_code
                },
                actionField: { step: 5, action: "chooseTerms" },
                pageTitle: 'Check scoring 1/4',
                eventId: 334
            });
            //new version
            let applStatusCode = this.state.appl_status_code || this.props.suggestion.application.appl_status_code
            gtm.sendEvent('base', {
                event: 'loan_application_decision_' + applStatusCode + '.received',
                products: {
                    loan_amount: this.props.suggestion.amount,
                    loan_period: this.props.suggestion.term,
                    product_code: this.props.suggestion.application.product_code || this.props.suggestion.application.appl_product,
                    application_number: this.props.suggestion.application.id,
                }
            }, 2);
            this.setState({ gtmScoringEventSent: true });
        }
    }

    componentDidMount() {
        this.getOptions();
    }

    getOptions() {

        const {clearError} = this.context;

        axios.get('/api/process/' + this.props.application_token + '/options')
            .then(
                data => {

                    let slider_ranges = this.state.slider_ranges;

                    data.data.data.spouse_info.spouse_personal_code
                        = decodeData(data.data.data.spouse_info.spouse_personal_code);

                    slider_ranges.min_term = data.data.data.terms_range.min_term;
                    slider_ranges.max_term = data.data.data.terms_range.max_term;

                    this.setState({
                        slider_ranges: slider_ranges,
                        options: data.data.data,
                        current_proposition: {
                            amount: data.data.data.additional_info.max_amount_to,
                            term: data.data.data.additional_info.max_term,
                            monthly_payment: null,
                        },
                        max_amount_proposition: {
                            amount: data.data.data.additional_info.max_amount_to,
                            term: data.data.data.additional_info.max_term,
                            monthly_payment: null,
                        },
                        initial_proposition: {
                            amount: data.data.data.additional_info.pref_amount,
                            term: data.data.data.additional_info.pref_term,
                            monthly_payment: null,
                        },
                        payment_day: data.data.data.additional_info.pref_pay_day,
                        appl_status_code: 'OK'
                    });

                    this.setTermToClosestAvailable();

                    this.getMonthlyPaymentFromApi(this.state.initial_proposition.amount, this.state.initial_proposition.term, (data) => {
                        this.setState({
                            initial_proposition: {
                                amount: this.state.initial_proposition.amount,
                                term: this.state.initial_proposition.term,
                                monthly_payment: data.data.deals.balance.installment_amount,
                            }
                        });
                    });

                    this.getMonthlyPaymentFromApi(this.state.max_amount_proposition.amount, this.state.max_amount_proposition.term, (data) => {
                        this.setState({
                            max_amount_proposition: {
                                amount: this.state.max_amount_proposition.amount,
                                term: this.state.max_amount_proposition.term,
                                monthly_payment: data.data.deals.balance.installment_amount,
                            }
                        });
                    });
                },
                error => {
                    let error_code = error.response.data.error_code;

                    this.setState({appl_status_code: error_code});

                    if (['SODRA_CLARIFY_CLIENT_INCOME', 'SODRA_CLARIFY_HAND_INCOME', 'SODRA_CLARIFY_INC'].includes(error_code)) {
                        this.setState({redirect_url: '/' + this.props.application_token + '/process/incomes_error'});
                    } else if (error_code === 'SPOUSE_INFO') {
                        clearError();
                        this.setState({redirect_url: '/' + this.props.application_token + '/process/error/SPOUSE_INFO'});
                    } else {
                        // if (error_code === null || error_code === '' || error_code === undefined) {
                        //     error_code = 'COULD_NOT_FINANCE'
                        // }
                        this.setState({options_error: true});
                    }
                }
            );
    }

    getMonthlyPaymentFromApi(amount, term, callback, cancelOtherRequests = false) {
        const {clearError} = this.context;
        let requestOptions = {};

        // Set to min if below minimum amount
        if (amount < this.state.slider_ranges.min_amount) {
            let current_proposition = this.state.current_proposition;
            current_proposition.amount = (amount < this.state.slider_ranges.min_amount) ? this.state.slider_ranges.min_amount : amount;
            this.setState({current_proposition: current_proposition});
        }

        const payload = {
            amount: amount,
            term: term
        };

        clearError();

        // Cancel other slider requests
        if (cancelOtherRequests) {
            if (cancelMonthlyPaymentRequests !== undefined) {
                cancelMonthlyPaymentRequests();
            }

            requestOptions = {
                cancelToken: new CancelToken(function executor(cancelExecutor) {
                    cancelMonthlyPaymentRequests = cancelExecutor;
                }),
            };
        }

        axios.post('/api/process/' + this.props.application_token + '/monthly_payment', payload, requestOptions)
            .then(response => {
                callback(response.data);
            })
            .catch(error => {
                this.setState({appl_status_code: error.response?.data?.error_code})
            })
    }

    /**
     * Slider functions
     */

    updateMonthlyPaymentInBottom(value) {//@todo rename
        let current_proposition = this.state.current_proposition;
        current_proposition.monthly_payment = value.data.deals.balance.installment_amount;
        this.setState({current_proposition: current_proposition});
    }

    updateAmountFromSlider(event) {
        let current_proposition = this.state.current_proposition;
        current_proposition.amount = parseInt(event.target.value);
        current_proposition.monthly_payment = null;

        this.setState({current_proposition: current_proposition})
    }

    updateTermFromSlider(event) {
        let current_proposition = this.state.current_proposition;
        current_proposition.term = parseInt(event.target.value);
        current_proposition.monthly_payment = null;

        this.setState({current_proposition: current_proposition});
    }

    getMonthlyPayment(event) { //@todo rename
        this.setTermToClosestAvailable();
    }

    setTermToClosestAvailable() {
        let current_proposition = this.state.current_proposition;

        if (this.state.options.terms[this.state.current_proposition.term] === undefined) {
            let closest_option = Object.keys(this.state.options.terms).reduce((previous, key) => {
                return this.getClosestValue(current_proposition.term, key, previous);
            }, 0);

            current_proposition.term = parseInt(closest_option);
        }

        this.setState({current_proposition: current_proposition});
        this.setAmountSliderRange();
    }

    setAmountSliderRange() {
        let current_term = this.state.current_proposition.term;
        if (this.state.options.terms[current_term]) {
            let slider_ranges = this.state.slider_ranges;

            slider_ranges.min_amount = this.state.options.terms[current_term].range.min_amount_for_term;
            slider_ranges.max_amount = this.state.options.terms[current_term].range.max_amount_for_term;

            this.setState({slider_ranges: slider_ranges});
            this.setAmountToClosestAvailable();
        }
    }

    setAmountToClosestAvailable() {
        const options = this.state.options.terms[this.state.current_proposition.term].options;
        let amount = this.state.current_proposition.amount;

        let closest_option = Object.keys(options).reduce((previous, key) => {
            let option_from = options[key].amount_from;
            let option_to = options[key].amount_to;

            if (option_from <= amount && amount <= option_to) {
                return amount;
            } else if (option_from > amount) {
                return this.getClosestValue(amount, previous, option_from)
            } else if (option_to < amount) {
                return this.getClosestValue(amount, previous, option_to)
            }
        }, 0);

        let current_proposition = this.state.current_proposition;
        current_proposition.amount = closest_option;
        this.setState({current_proposition: current_proposition});
        this.getMonthlyPaymentFromApi(
            this.state.current_proposition.amount,
            this.state.current_proposition.term,
            this.updateMonthlyPaymentInBottom,
            true
        )
    }

    getClosestValue(goal, first_value, second_value) {
        return (Math.abs(first_value - goal) < Math.abs(second_value - goal) ? first_value : second_value);
    }

    choosePaymentDay(event) {
        this.setState({payment_day: event.target.value});

        axios.post('/api/process/' + this.props.application_token + '/pay_day', {payment_day: event.target.value});
    }

    hideSIFModal() {
        this.setState({is_modal_shown: false})
    }

    updateDealData(proposition) {
        this.setState({
            deal: null,
            application: null,
        });

        const { application_token } = this.props;
        const { processStep } = this.context;

        axios.post('/api/process/' + application_token + '/terms', proposition)
            .then(
                data => {
                    if (data.data.status === 'success') {
                        this.setState({deal: data.data.data});


                        axios.get('/api/process/' + application_token + '/info',
                            {
                                params: {step: processStep}
                            }).then(
                                data => {
                                    this.setState({
                                        application: data.data.data
                                    });
                                }
                            );
                    }
                },
                error => {
                    this.hideSIFModal();
                }
            );
    }

    showSif(proposition) {
        this.setState({
            is_modal_shown: true,
            is_preview_modal_shown: false,
        });

        this.updateDealData(proposition);
    }

    showPreview(proposition) {
        this.setState({
            is_preview_modal_shown: true,
        });

        this.updateDealData(proposition);
    }

    hidePreviewModal() {
        this.setState({is_preview_modal_shown: false})
    }

    // rendering functions

    canShowInitialProposition() {
        if (this.state.initial_proposition.amount !== null && this.state.initial_proposition.monthly_payment !== null && this.state.initial_proposition.term !== null) {
            return this.state.initial_proposition.amount <= this.state.max_amount_proposition.amount;
        }

        return false;
    }

    renderTermForm(props) {
        return (<div>
            {this.state.current_proposition.amount !== null ?
                <div className="row py-5 align-items-center px-4">
                    <div className="col-12">
                        <h2 className="heading--2">{this.props.t('forms.other_amount')}</h2>
                    </div>
                    <div className="col-12">
                        <Form className="js-loan-calc">
                            <div className="row align-items-center py-4">
                                <div className="col-12 col-lg-7 col-xl-8 slider range-slider pr-0 pr-lg-4 border-0">
                                    <div className="row">
                                        <div className="col-12">
                                            <label htmlFor="amount" className="calc__label">
                                                {this.props.t('forms.loan_amount')}
                                            </label>
                                        </div>
                                        <div className="col-12 col-md-8 pt-2 calc">
                                            <ReactBootstrapSlider
                                                value={this.state.current_proposition.amount}
                                                change={this.updateAmountFromSlider}
                                                slideStop={this.getMonthlyPayment}
                                                step={5}
                                                min={this.state.slider_ranges.min_amount}
                                                max={this.state.slider_ranges.max_amount}
                                                formatter={(value) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + this.props.t('currency')}
                                            />
                                            <span className="calc__limit-min">
                                                <NumberFormat thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType={"text"}
                                                              value={this.state.slider_ranges.min_amount}/> {this.props.t('currency')}
                                            </span>
                                            <span className="calc__limit-max">
                                                <NumberFormat thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType={"text"}
                                                              value={this.state.slider_ranges.max_amount}/> {this.props.t('currency')}
                                            </span>
                                        </div>
                                        {props.values.amount !== null ?
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <div className="input-group">
                                                        <Field type="number"
                                                               name="amount"
                                                               className={"form-control d-block" + (props.errors.amount && props.touched.amount ? ' is-invalid' : '')}
                                                               id="amount"
                                                               onBlur={this.getMonthlyPayment}
                                                               onChange={this.updateAmountFromSlider}
                                                        />
                                                        <div className="input-group-append">
                                                            <div className="input-group-text">{this.props.t('currency')}</div>
                                                        </div>
                                                    </div>
                                                    <ErrorMessage name="amount" component="div"
                                                                  className="invalid-feedback  definitely-show"/>
                                                </div>
                                            </div>
                                            : ''}

                                        <div className="col-8 col-lg-12 mt-4">
                                            <label htmlFor="period" className="calc__label">
                                                {this.props.t('forms.choose_term')}
                                            </label>
                                        </div>
                                        <div className="col-12 col-md-8 pt-2 pb-lg-4 calc">
                                            <ReactBootstrapSlider
                                                value={this.state.current_proposition.term}
                                                change={this.updateTermFromSlider}
                                                slideStop={this.getMonthlyPayment}
                                                step={1}
                                                min={this.state.slider_ranges.min_term}
                                                max={this.state.slider_ranges.max_term}
                                                formatter={(value) => value + " " + this.props.t('month')}
                                            />
                                            <span
                                                className="calc__limit-min">{this.state.slider_ranges.min_term} {this.props.t('month')}</span>
                                            <span
                                                className="calc__limit-max">{this.state.slider_ranges.max_term} {this.props.t('month')}</span>
                                        </div>
                                        {props.values.term !== null ?
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <div className="input-group">
                                                        <Field type="number"
                                                               name="term"
                                                               className={"form-control d-block" + (props.errors.term && props.touched.term ? ' is-invalid' : '')}
                                                               id="term"
                                                               onBlur={this.getMonthlyPayment}
                                                               onChange={this.updateTermFromSlider}
                                                        />
                                                        <div className="input-group-append">
                                                            <div className="input-group-text">mėn</div>
                                                        </div>
                                                    </div>
                                                    <ErrorMessage name="amount" component="div"
                                                                  className="invalid-feedback  definitely-show"/>
                                                </div>
                                            </div>
                                            : ''}
                                    </div>
                                </div>


                                <div className="col-12 col-lg-5 col-xl-4">
                                    {this.state.current_proposition.monthly_payment === '' ?
                                        <Loading/>
                                        :
                                        <div className="custom-card w-100 mt-4 mt-lg-0">
                                            <p className="calc__result-title custom-card__title text-center mb-3">{this.props.t('forms.monthly_payment')}</p>
                                            <span
                                                className="d-block js-calc-result-monthly custom-card__value text-center mb-4">
                                                {this.state.current_proposition.monthly_payment === null ?
                                                    <NumberLoading postfix={this.props.t('currency')}/>
                                                    :
                                                    <div>
                                                        <NumberFormat thousandSeparator={'.'}
                                                                      decimalSeparator={','}
                                                                      displayType={"text"}
                                                                      value={this.state.current_proposition.monthly_payment}/>&nbsp;{this.props.t('currency')}
                                                    </div>
                                                }
                                        </span>
                                            <button
                                                className="btn btn-primary btn-lg custom-card__btn"
                                                disabled={this.state.current_proposition.monthly_payment === null}
                                            >
                                                {this.props.t('forms.create_contract')}
                                            </button>

                                            <p className="fake-link text-center" onClick={() => {
                                                this.showPreview({
                                                    amount: this.state.current_proposition.amount,
                                                    term: this.state.current_proposition.term
                                                })
                                            }}>
                                                {this.props.t('preview')}
                                            </p>
                                        </div>
                                    }
                                </div>
                            </div>

                        </Form>

                    </div>
                </div>
                : ''}
        </div>);
    }

    generateMonth() {
        let days = [];
        for (let i = 1; i < 32; i++) {
            days.push(
                <li className="custom-calendar__day" key={i}>
                    <label htmlFor={"custom-calendar-day-" + i}
                           className="custom-calendar__label">
                        <input id={"custom-calendar-day-" + i}
                               type="radio"
                               name="pick_payment_day"
                               value={i}
                               onChange={this.choosePaymentDay}
                               checked={(i == this.state.payment_day)}
                        />
                        <span>{i}</span>
                    </label>
                </li>
            )
        }
        return days;
    }

    scrollToCalculator() {
        this.calculatorRef.current.scrollIntoView({behavior: "smooth"});
    }

    render() {
        if (this.state.redirectToNextStep) {
            return <Redirect push={true} to={'/' + this.props.application_token + '/process/aml'}/>
        }

        if (this.state.redirectToSpouseStep) {
            return <Redirect push={true} to={'/' + this.props.application_token + '/process/income_family'}/>
        }

        if (this.state.redirect_url !== null && this.state.redirect_url !== undefined) {
            return <Redirect push={true} to={this.state.redirect_url}/>
        }

        return (
            <div>
                <Header title={this.props.t('step.proposal')}/>

                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader
                            step_count={this.state.step_count}
                            current_step={this.state.current_step}/>

                        {this.state.max_amount_proposition.amount === null ?
                            <Fragment>
                                {!this.state.options_error &&
                                    <Loading msg={this.props.t('waiting_for_options')}/>
                                }
                            </Fragment>
                            :
                            <Fragment>

                                <div
                                    className={'row align-items-center border-bottom border-gray-cloud px-3' + (!this.state.options.spouse_info.spouse_available ? 'py-5' : '')}>
                                    <div className="col-12 col-md-12 col-lg-7 col-xl-8">
                                        <div className="wrapper wrapper--1-3 justify-content-between">

                                            {this.canShowInitialProposition() ?
                                                <div className="proposition col-12 col-lg-6 text-center my-2 my-lg-5">
                                                    <Proposition title={this.props.t('initial_proposition')}
                                                                 amount={this.state.initial_proposition.amount}
                                                                 monthly={this.state.initial_proposition.monthly_payment}
                                                                 term={this.state.initial_proposition.term}
                                                                 showSif={this.showSif}
                                                                 showPreview={this.showPreview}
                                                    />
                                                </div>
                                                : ''}

                                            <div
                                                className={"proposition col-12 col-lg-6 text-center my-2 my-lg-5 " + (!this.canShowInitialProposition() ? 'offset-lg-3' : '')}>
                                                <Proposition title={this.props.t('max_loan_amount')}
                                                             amount={this.state.max_amount_proposition.amount}
                                                             monthly={this.state.max_amount_proposition.monthly_payment}
                                                             term={this.state.max_amount_proposition.term}
                                                             showSif={this.showSif}
                                                             showPreview={this.showPreview}
                                                />
                                            </div>

                                            <div className="w-100 text-center">
                                                <p onClick={this.scrollToCalculator}
                                                   className="fake-link line-animation mt-5 mt-lg-0">
                                                    {this.props.t('will_chooce_different_amount')}
                                                </p>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="col-12 col-md-12 col-lg-5 col-xl-4 my-5">
                                        <div className="custom-calendar">
                                            <h3 className="custom-calendar__title">Pasirinkite įmokų mokėjimo dieną</h3>
                                            <ul className="custom-calendar__body">
                                                {this.generateMonth()}
                                            </ul>
                                        </div>

                                        {this.state.options.spouse_info.spouse_available &&
                                        <div className="spouse-suggestion-container mt-5 mt-lg-3">
                                            Jeigu paskola yra skirta šeimos reikmėms,
                                            siūlome atlikti kreditingumo vertinimą kartu su sutuoktiniu
                                            <br/>
                                            <button className="btn btn-primary"
                                                    onClick={() => {
                                                        this.setState({redirectToSpouseStep: true})
                                                    }}
                                            >{this.props.t('forms.begin_btn')}</button>
                                        </div>
                                        }
                                    </div>
                                </div>

                                <div ref={this.calculatorRef}>
                                    <Formik
                                        initialValues={this.state.current_proposition}
                                        onSubmit={() => {
                                            this.showSif({
                                                amount: this.state.current_proposition.amount,
                                                term: this.state.current_proposition.term
                                            })
                                        }}
                                        render={this.renderTermForm}
                                        enableReinitialize={true}
                                    />
                                </div>
                            </Fragment>
                        }

                        <SIF
                            deal={this.state.deal}
                            is_modal_shown={this.state.is_modal_shown}
                            hideSIFModal={this.hideSIFModal}
                            application={this.state.application}
                            callback={() => {
                                this.setState({redirectToNextStep: true})
                            }}
                            type={this.props.suggestion.type}
                            application_token={this.props.application_token}
                        />
                        <ContractPreview
                            deal={this.state.deal}
                            application_token={this.props.application_token}
                            is_preview_modal_shown={this.state.is_preview_modal_shown}
                            application={this.state.application}
                            hidePreviewModal={this.hidePreviewModal}
                            showSif={this.showSif}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ChooseTerms);
